import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';

@Injectable()
export class ImpersonateInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const regexApiAuth = /\/api\/auth/;
    const switchUserName = this.authService.getSwitchedUser();

    const request =
      req.url.match(regexApiAuth) || !switchUserName
        ? req
        : req.clone({
            setHeaders: {
              'x-switch-user': `${switchUserName}`
            }
          });

    return next.handle(request);
  }
}
